import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { FileFormats } from "../../../../../components/finalForms/libs/data/fileFormatTypes";

const initState = {
  sShipCountry: "",
  sShipName1: "",
  sShipName2: "",
  sAddressLine1: "",
  sAddressLine2: "",
  sCity: "",
  sState: "",
  sZipCode: "",

  sBillCountry: "",
  sBillName1: "",
  sBillName2: "",
  sBillAddressLine1: "",
  sBillAddressLine2: "",
  sBillCity: "",
  sBillState: "",
  sBillZipCode: "",
};

export const productSalesShippingAddressField = {
  name: "Document",
  initialState: initState,
  section: [
    {
      sectionId: "shippingAddressSection",
      title: "Shipping Address Section",
      row: {},
      style: {
        sectionStyle: "col-lg-6 col-md-6 pr-5",
      },
      wrapperTemplate: <div className="form-card address-main-sec row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "shippingAddressSection",
          label: "",
          fieldType: FormFieldTypes.MAINFORMTITLE,
          fieldSetting: {
            formTitle: "Shipping Address",
          },
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "sShipCountry",
          label: "Country :",
          Field_Name: "Country",
          fieldType: FormFieldTypes.SELECT,
          dataField: "sShipCountry",
          fieldSetting: {
            placeholder: " ",
            options: [],
            isLoading: false,
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2 validation-left-0",
          },
        },
        {
          id: "sShipName1",
          label: "Ship To Name :",
          Field_Name: "Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sShipName1",
          fieldSetting: {
            placeholder: " ",
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2",
          },
        },
        {
          id: "sShipName2",
          label: " ",
          Field_Name: "sShipName2",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sShipName2",
          fieldSetting: {
            placeholder: " ",
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2",
          },
        },
        {
          id: "sAddressLine1",
          label: "Address :",
          Field_Name: "Address",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sAddressLine1",
          fieldSetting: {
            placeholder: " ",
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2",
          },
        },
        {
          id: "sAddressLine2",
          label: " ",
          Field_Name: "Address Line 2",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sAddressLine2",
          fieldSetting: {
            placeholder: " ",
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2",
          },
        },
        {
          id: "sZipCode",
          label: "Zip/City/State :",
          Field_Name: "Zip",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sZipCode",
          fieldSetting: {
            placeholder: " ",
            isEnableOnChange: true,
          },
          style: {
            containerCss: "col-xxl-3 col-lg-5 mb-2 pr-0",
          },
        },
        {
          id: "sCity",
          label: "",
          Field_Name: "City",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sCity",
          fieldSetting: {
            placeholder: " ",
            isLoading: false,
          },
          style: {
            containerCss: "col-xxl-3 col-lg-10 mb-2 validation-left-0",
          },
        },
        {
          id: "sState",
          label: "",
          Field_Name: "State",
          fieldType: FormFieldTypes.SELECT,
          dataField: "sState",
          fieldSetting: {
            placeholder: " ",
            options: [],
            isLoading: false,
          },
          style: {
            containerCss: "col-xxl-3 col-lg-3 mb-2 validation-left-0",
          },
        }
      ],
    },
    {
      sectionId: "billingAddressSection",
      title: "Billing Address Section",
      row: {},
      style: {
        sectionStyle: "col-lg-6 col-md-6  pl-5",
      },
      wrapperTemplate: <div className="form-card address-main-sec row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "billingAddressSection",
          label: "",
          fieldType: FormFieldTypes.MAINFORMTITLE,
          fieldSetting: {
            formTitle: "Billing Address",
          },
          style: {
            containerCss: "col-lg-12 col-md-12",
          },
        },
        {
          id: "sBillCountry",
          label: "Country :",
          Field_Name: "Country",
          fieldType: FormFieldTypes.SELECT,
          dataField: "sBillCountry",
          fieldSetting: {
            placeholder: " ",
            options: [],
            isLoading: false,
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2 validation-left-0",
          },
        },
        {
          id: "sBillName1",
          label: "Ship To Name :",
          Field_Name: "Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sBillName1",
          fieldSetting: {
            placeholder: " ",
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2",
          },
        },
        {
          id: "sBillName2",
          label: " ",
          Field_Name: "Client",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sBillName2",
          fieldSetting: {
            placeholder: " ",
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2",
          },
        },
        {
          id: "sBillAddressLine1",
          label: "Address :",
          Field_Name: "Address",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sBillAddressLine1",
          fieldSetting: {
            placeholder: " ",
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2",
          },
        },
        {
          id: "sBillAddressLine2",
          label: " ",
          Field_Name: "Address Line 2",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sBillAddressLine2",
          fieldSetting: {
            placeholder: " ",
          },
          style: {
            containerCss: "col-xxl-10 col-lg-10 mb-2",
          },
        },
        {
          id: "sBillZipCode",
          label: "Zip/City/State/ :",
          Field_Name: "Zip",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sBillZipCode",
          fieldSetting: {
            placeholder: " ",
            isLoading: false,
          },
          style: {
            containerCss: "col-xxl-3 col-lg-10 mb-2 validation-left-0",
          },
        },
        {
          id: "city",
          label: "",
          Field_Name: "City",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sBillCity",
          fieldSetting: {
            placeholder: " ",
            isEnableOnChange: true,
          },
          style: {
            containerCss: "col-xxl-3 col-lg-5 mb-2 pr-0",
          },
        },
        {
          id: "sBillState",
          label: "",
          Field_Name: "State",
          fieldType: FormFieldTypes.SELECT,
          dataField: "sBillState",
          fieldSetting: {
            placeholder: " ",
            options: [],
            isLoading: false,
          },
          style: {
            containerCss: "col-xxl-3 col-lg-10 mb-2 validation-left-0",
          },
        },
      ],
    },
  ],
};
